import React, { useQuery, useState } from 'react';
import styled from '@emotion/styled/macro';
import { css } from '@emotion/core';

import { DriverIcon, SeatIcon, WcIcon } from 'components';
import { useMutation } from '@apollo/react-hooks';
import {
  ADD_CART_REPLACED,
  Empty_pending_seat,
  getTrip,
} from '../../../services';
import { notify } from '../../../utilities';
import { Spin } from 'antd';

const GridContainer = styled.div`
  margin-right: 15px;
  .delete {
    display: contents;
    position: absolute;
    color: red;
    cursor: pointer;
  }
  .apply {
    margin: 10px;
    border-radius: 14px;
    height: 50px;
    font-size: 16px;
    float: right;
  }
`;

const SeatsGrid = styled.div`
  text-align: center;
  display: inline-block;
  flex-direction: column;
  padding: 10px;
`;

const StyleIcon = css`
  display: inline-block;
  margin: 10px 12px;
  background-color: transparent;
  vertical-align: top;
  padding: 0;
  border: none;
  text-align: center;
`;

const Seat = styled.button`
  ${StyleIcon}
  fill: ${(props) => props.color};
  cursor: pointer;
  &:disabled {
    cursor: not-allowed;
  }
  position: relative;

  svg {
    width: 35px;
    height: 35px;

    :active {
      fill: blue;
    }
  }

  p {
    margin-bottom: 0;
  }
    
`;

const NASeat = styled.div`
  width: 35px;
  height: 35px;
`;

const RowContainer = styled.div``;

const BusSalon = ({
  data,
  exit_modal,
  allSeatTypes,
  handleSubmit,
  reservedSeats,
  trip: {
    id: tripId,
    busSalon: { layout: seats },
    routeLine: { id: routeLineId },
  },
}) => {
  function selectSeat(seatNumber, seatTypeId) {
    setSelectedSeat(seatNumber);
    setSelectedSeatType(seatTypeId);
  }

  const handleOk = () => {
    var mut = {
      cartToken: data.cartToken,
      ticket_id: data.ticket_id,
      tickets: {
        trip_id: tripId,
        trip_route_line_id: routeLineId,
        from_location_id: data.from,
        to_location_id: data.to,
        seat_type_id: selectedSeatType,
        seat_number: selectedSeat,
      },
    };
    addCartTickets({
      variables: mut,
    })
      .then((response) => {
        notify('success', 'Ticked Replaced Successfully');
        handleSubmit();
      })
      .catch((err) => {
        const {
          extensions: { validation },
          message,
        } = err['graphQLErrors'][0];

        if (validation) {
          for (let error in validation) {
            notify('error', validation[error][0]);
          }
        } else {
          notify('error', message);
        }
      });
  };

  const [addCartTickets, { loading: addCartTicketLoading }] = useMutation(
    ADD_CART_REPLACED
  );
  const [empty_pending_seat] = useMutation(Empty_pending_seat);
  const [selectedSeat, setSelectedSeat] = useState(null);
  const [selectedSeatType, setSelectedSeatType] = useState(null);

  let previousSeatType = '';
  return (
    <GridContainer>
      <SeatsGrid>
        {seats.map((row, idx) => {
          let currentSeatType;
          const firstSeatInRow = row.find((seat) => seat.type === 'SEAT');
          if (firstSeatInRow) {
            const { seat_type_id: firstSeatInRowType } = firstSeatInRow;
            const { name_en: seatTypeNameEn } = allSeatTypes.find(
              (seatType) => seatType.id === firstSeatInRowType
            );
            currentSeatType =
              seatTypeNameEn !== previousSeatType ? seatTypeNameEn : null;

            previousSeatType =
              currentSeatType !== null ? currentSeatType : previousSeatType;
          }

          return (
            <>
              {currentSeatType && <p>{currentSeatType}</p>}
              <RowContainer key={idx}>
                {row.map((seat) => {
                  const {
                    key,
                    numbering,
                    seat_type_id: seatTypeId,
                    type,
                  } = seat;
                  // const { name_en: seatTypeName } = allSeatTypes.find(
                  //   (seat) => seat.id == seatTypeId
                  // );
                  const reserved = reservedSeats.find(
                    (s) => s.seat_number == numbering
                  );
                  return (
                    <Seat
                      key={seat.id}
                      disabled={
                        type !== 'SEAT' ||
                        ((reserved ? true : undefined) &&
                          reserved &&
                          reserved.status !== 'Pending')
                      }
                      title={
                        reserved &&
                        reserved.status === 'Pending' &&
                        'Set To Empty'
                      }
                      color={(() => {
                        if (selectedSeat === numbering && type == 'SEAT') {
                          return 'blue';
                        } else if (reserved && reserved.status === 'Pending')
                          return 'yellow';
                        else if (reserved && reserved.status !== 'Pending')
                          return 'red';
                        else return 'lightgray';
                      })()}
                      onClick={() => {
                        if (reserved && reserved.status === 'Pending') {
                          empty_pending_seat({
                            variables: {
                              trip_id: tripId,
                              seat_number: numbering,
                            },
                          })
                            .then((response) => {
                              const {
                                data: { empty_pending_seat },
                              } = response;
                              exit_modal();
                              notify(
                                'success',
                                'seat is set to empty successfully '
                              );
                            })
                            .catch((err) => {
                              console.log(err);
                              exit_modal();
                            });
                        } else selectSeat(numbering, seatTypeId);
                      }}
                    >
                      {type === 'SEAT' && <SeatIcon />}
                      {type === 'WC' && <WcIcon />}
                      {type === 'NA' && <NASeat />}
                      {type === 'DRIVER' && <DriverIcon />}
                      <p>{numbering}</p>
                      {reserved &&
                        reserved.status === 'Pending' &&
                        selectedSeat !== numbering && (
                          <div>
                            <i className={'delete'}>X</i>
                          </div>
                        )}
                    </Seat>
                  );
                })}
              </RowContainer>
            </>
          );
        })}
      </SeatsGrid>
      <button
        onClick={handleOk}
        type="primary"
        className={'ant-btn ant-btn-primary apply'}
      >
        {addCartTicketLoading ? (
          <Spin>replacing ticket</Spin>
        ) : (
          'apply replace ticket'
        )}
      </button>
    </GridContainer>
  );
};
export default BusSalon;
